import { Library } from "@bandstand/core/Library";
import type { IStorage } from "@bandstand/core/IStorage";

import { DisplayStore } from "./DisplayStore";
import { EditorStore } from "./EditorStore";
import { LibraryStore } from "./LibraryStore";
import { deviceKeys } from "../share/deviceKeys";
import { ShareClient } from "../share/ShareClient";
import { AccountStore } from "./AccountStore";
import { NavigationStore } from "./NavigationStore";
import { SettingsStore } from "./SettingsStore";
import { SettingsSync } from "./SettingsSync";
import { ThemeStore } from "./ThemeStore";
import { ViewerStore } from "./ViewerStore";

/** Holds every store. Components get it with `useStores()`. */
export class RootStore {
    readonly library: LibraryStore;

    readonly navigation = new NavigationStore();

    readonly display = new DisplayStore();

    readonly theme = new ThemeStore();

    readonly settings = new SettingsStore();

    readonly account: AccountStore;

    readonly settingsSync: SettingsSync;

    readonly viewer: ViewerStore;

    readonly editor: EditorStore;

    constructor(storage: IStorage, share = new ShareClient(deviceKeys)) {
        this.library = new LibraryStore(new Library(storage));
        this.viewer = new ViewerStore(this.library, this.navigation);
        this.editor = new EditorStore(this.library, this.navigation);
        this.account = new AccountStore(share);
        this.settingsSync = new SettingsSync(share, this.account, this.theme, this.display, this.settings);
    }

    /** Loads everything again after the library changed outside the app, like a file synced from another computer. */
    async sync(): Promise<void> {
        await this.library.load();
        await this.viewer.refresh();
    }
}
